import React from 'react'
import { connect } from 'react-redux'
import { Redirect, Link } from 'react-router-dom'

import Loader from './Loader'

import Typography from '@material-ui/core/Typography';

import { withStyles } from '@material-ui/core/styles';
import {table as styles} from './Mui/styles';

import Icon from '@material-ui/core/Icon';
import CachedIcon from '@material-ui/icons/Cached';

import CustomDialog from './inputs/CustomDialog'

import InstaTable from './InstaTable'
// import RedeemIcon from './Mui/RedeemIcon'

import {
  coupons_index,
  reset_campaign_token,
  clear_coupon,
  set_path,
} from '../actions'

import {
  is_logged_on,
  is_validating,
  capitalize
 } from "../helpers"

const mapStateToProps = state => {
  const { items, pagination, totals } = state.coupon
  return {
    coupon: state.coupon,
    coupons: items,
    pagination: pagination,
    totals: totals,
    current_user: state.auth.current_user.data
  }
}

const mapDispatchToProps = dispatch => {
  return {
    getCoupons: (page=1, per_page=10, filters={}, sort='', order='') => dispatch( coupons_index(page, per_page, filters, sort, order) ),
    resetCampaignToken: (coupon_id, index, page=1, per_page=10, filters={}, sort="", order="") => dispatch( reset_campaign_token(coupon_id, true, page, per_page, filters, sort, order) ),
    clearCoupon: () => dispatch( clear_coupon() ),
    setPath: path => dispatch( set_path(path) ),
  }
}

class ConnectedCouponsIndex extends React.Component {
  state={
    current_coupon: {},
    current_view: 'all',
    merge_filters: {},
    current_id: undefined,
    filterState: {},
    showDialog: false,
    dialogState: {},
    mounted: false
  }

  fieldGetter(field, item, instate) {
    let renderText
    const state = {
      ...instate,
      filters: {
        ...instate.filters,
        ...this.state.merge_filters
      }
    }
    if (field === "valid_from" || field === "valid_to" || field === "created_at" ) {
      renderText = item[field] ? new Date(item[field]).toLocaleDateString() : ''
    } else if (field === "status") {
      renderText = this.statusIcon(item[field])
    } else if (field === 'id' || field === 'campaign_token') {
      renderText = item[field]
    } else if (field === 'discount') {
      renderText = item.discount > 0 ? `${parseInt(item.discount * 100, 10)} %` : `${item.value.toFixed(2)} €`
    } else if ( ['limit', 'usage', 'vouchers'].indexOf(field) > -1 ) {
      renderText = item[field]
    } else if (field === "actions" ) {
      renderText = (
        <React.Fragment>
          {
            this.resetTokenLink(item, state)
          }
        </React.Fragment>
      )
    } else {
      renderText = item[field] ? capitalize(item[field]) : ''
    }
    return renderText
  }

  componentWillMount() {
    const { getCoupons } = this.props
    getCoupons()
    this.props.setPath('coupons')
}

  componentWillUnmount() {
    // this.props.resetTemplate()
  }

  componentDidUpdate(prevProps, prevState) {
    if (!this.state.mounted) {
      if (prevProps.coupon.fetching && !this.props.coupon.fetching && this.props.coupon.fetched) {
        this.setState({mounted: true})
      }
    }
  }

  handleStatus = value => {
    if (value === 'all') {
      this.setState({merge_filters: {}})
    } else {
      this.setState({merge_filters: {status: value}})
    }
    this.setState({current_view: value})
  }

  statusIcon = status => {
    let icon = null
    if (status === 'published') {
      icon = 'check_circle'
    } else if (status === 'draft') {
      icon = 'insert_drive_file'
    } else if (status === 'expired') {
      icon = 'timer_off'
    } else if (status === 'consumed') {
      icon = "done_all"
    } else if (status === 'revoked') {
      icon = "delete"
    }
    if (icon !== null) {
      return <Icon style={{color: 'rgba(0,0,0,0.87)', fontSize: '16px'}} title={capitalize(status)}>{icon}</Icon>
    }
  }

  resetTokenLink = (item, state) => {
    const { id } = item
    return (
      <Link to="" className="action-btn" title="Reset Campaign Token" onClick={e=>{
        e.preventDefault()
        this.setState({showDialog: true, current_coupon: item, dialogState: state})
      }}>
        <CachedIcon style={{color: 'rgba(0,0,0,0.87)', fontSize: '18px'}} />
      </Link>
    )
  }

  resetTokenAction = () => {
    const { mounted, current_coupon, dialogState } = this.state
    if (mounted && current_coupon.id) {
      const { page, per_page, filters, sort, order } = dialogState
      const { id } = current_coupon
      this.props.resetCampaignToken(id, true, page, per_page, filters, sort, order)
      this.hideDialog()
    }
  }

  hideDialog() {
    this.setState({showDialog: false, current_coupon: {}, dialogState: {}})
  }

  render() {
    if ( !is_logged_on() && !is_validating() ) {
      return <Redirect to="/" />
    }

    const { coupons, pagination, totals } = this.props

    if (!this.state.mounted) {
      return <Loader />
    }

    const columns = [
      { id: 'id', disablePadding: true, label: 'ID', disableSort: true },
      { id: 'name', disablePadding: true, label: 'Name' },
      { id: 'description', disablePadding: true, label: 'Description', disableSort: true },
      { id: 'status', disablePadding: true, label: 'Status', disableSort: true },
      { id: 'discount', disablePadding: true, label: 'Discount', disableSort: true },
      { id: 'valid_to', disablePadding: true, label: 'Expiry' },
      { id: 'limit', disablePadding: true, label: 'Max use' },
      { id: 'vouchers', disablePadding: true, label: 'Vouchers', disableSort: true },
      { id: 'usage', disablePadding: true, label: 'Redeemed' },
      { id: 'campaign_token', label: 'Campaign Token', disableSort: true },
      { id: 'actions', disablePadding: true, label: 'Actions', disableSort: true },
    ]

    const filterControls = [
      { name: "search", filter_type: "search" },
      { name: "valid_to", filter_type: "date", prefix: "valid_to_", startLabel: "Expiry from" },
    ]

    const statuses = [
      { name: "all", label: "All", value: totals.all },
      { name: "published", label: "Active", value: totals.published },
      { name: "expired", label: "Expired", value: totals.expired },
      { name: "consumed", label: "Consumed", value: totals.consumed },
    ]

    return (
      <div id="feedbacks-wrapper" className={this.props.coupon.fetching ? "fetching-list" : ''}>
        <div className="d-flex justify-content-between mb-40">
          <Typography className=" fw-bold h4">
            Coupons
          </Typography>
        </div>

        <InstaTable
          statuses={statuses}
          columns={columns}
          filterControls={filterControls}
          rows={coupons}
          pagination={pagination}
          userRole={'client'}
          search={true}
          placeholders="ID, name, description"
          merge_filters={this.state.merge_filters}
          rowGetter={this.props.getCoupons.bind(this)}
          fieldGetter={this.fieldGetter.bind(this)}
          current_view={this.state.current_view}
          handleStatus={this.handleStatus.bind(this)}
          classPrefix="coupons"
          addClassField="status"
        />

        <CustomDialog
          id="delete-dialog"
          fullScreen = {false}
          isopen={this.state.showDialog}
          handleClose={this.hideDialog.bind(this)}
          handleAccept={this.resetTokenAction.bind(this)}
          title="Reset Campaign Token?"
        >
          This will invalidate all running campaigns for this coupon.
        </CustomDialog>
      </div>
    )
  }
}

const CouponsIndex = connect(mapStateToProps, mapDispatchToProps)(ConnectedCouponsIndex)

export default withStyles(styles)(CouponsIndex)



// WEBPACK FOOTER //
// ./src/js/components/CouponsIndex.js